import classNames from 'classnames';

import Logo from './logo.svg?react';
import LogoLeaf from './logo-sm.svg?react';

type Props = {
    leaf?: boolean;
    className?: string;
};

export const Brand = ({ leaf = false, className }: Props) => {
    const cn = classNames('h-10 text-logo', className ?? '');

    if (leaf) {
        return (
            <LogoLeaf role="img" aria-label="Bigleaf Networks" className={cn} />
        );
    }

    return <Logo role="img" aria-label="Bigleaf Networks" className={cn} />;
};
